import React from "react";
import useControlAttribute from "../../../hooks/useControlAttribute";
import { IControlComfoair350, TComfoair350ValueAttribute } from "../types";
import { useTranslation } from "react-i18next";

const fanValuePositions = {
  fan_state_exhaust_rpm: { top: "24%", right: "45%" },
  fan_state_intake_rpm: { top: "84%", right: "45%" },
  temp_exhaust: { top: "41%", right: "74%" },
  temp_supply: { top: "41%", right: "14%" },
  temp_outside: { top: "67%", right: "74%" },
  temp_return: { top: "67%", right: "14%" },
};

interface IComfoair350FanValueProps {
  control: IControlComfoair350;
  attribute: TComfoair350ValueAttribute;
}

const Comfoair350AttributeValue = (props: IComfoair350FanValueProps) => {
  const { control, attribute } = props;
  const value = useControlAttribute(control, attribute);
  const { t } = useTranslation();
  const isFanAttribute = attribute.startsWith("fan");
  return (
    <div
      style={{
        color: isFanAttribute ? "black" : "white",
        position: "absolute",
        ...fanValuePositions[attribute],
      }}
    >
      {value.toFixed(isFanAttribute ? 0 : 1)} {isFanAttribute ? t("rpm") : "°C"}
    </div>
  );
};

export default Comfoair350AttributeValue;
